import axios from 'axios'
import { useState, useEffect,  } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'

import { Card, CardContent, Typography, Button, InputAdornment, Snackbar, Dialog, IconButton, Tooltip } from '@mui/material'
import { Close, VpnKey, Email, Visibility, VisibilityOff } from '@mui/icons-material'
import Formsy from 'formsy-react'

import { C, D, Loading, TextFieldFormsy, openLink, obj2form } from './include'
import { MainPage } from './views/Main'

// ==========================================
// SCREEN COMPONENT
// ==========================================
function Screen({ children }) {
  return (
    <D className="r2c e aF" style={{ backgroundColor: '#424242', padding: '30px' }}>
      <D className="e hide-sm" />
      <D className="col e aF" p="3">
        <D className="e hide-sm" />
        <D h="30px" />
        <D col p="2" img={C.coverIMG} side />
        <Typography className="row w aC" variant="h3" color="white">
          <sup style={{ fontSize: '0.4em', verticalAlign: 'super' }}>{'\u00A9 '}</sup>{C.appNAME}
        </Typography>
        <D className="row w aC hv" onClick={() => openLink('http://ai2bizlab.com.br')} style={{ cursor: 'pointer' }}>
          <Typography className="row w aC" variant="subtitle1" color="white">
            <b>Criado por</b>
            <img style={{ margin: '0 8px', height: '20px', verticalAlign: 'middle' }} src={C.ai2IMG} alt="logo" />
            <b>Business</b>
          </Typography>
        </D>
        <D className="e hide-sm" />
      </D>
      <D className="e hide-sm" />
      <D className="col e aF" p="3">
        <D className="e hide-sm" />
        <D className="row aC">
          <Card className="row aF" square style={{ minWidth: '350px' }}>
            <CardContent className="col e aF">
              <D h="1rem" />
              {children}
              <D h="1rem" />
            </CardContent>
          </Card>
        </D>
        <D e />
      </D>
      <D className="e hide-sm" />
    </D>
  )
}

// ==========================================
// LOGIN COMPONENT
// ==========================================
function Login({ doLogin }) {
  const [email, setEmail] = useState('')
  const [pwd, setPwd] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  return (
    <Screen>
      <Typography variant="h6" className="row w aC">Acesso</Typography>
      <D h="1rem" />
      <Formsy onValidSubmit={() => doLogin(email, pwd)} className="col w aF">

        {/* INPUT E-MAIL */}
        <TextFieldFormsy 
          required 
          type="text" 
          name="email"
          autoComplete="email"
          label="E-mail" 
          value={email} 
          onChange={e => setEmail(e.toLowerCase())} 
          validations="isEmail"
          validationErrors={{ isEmail: 'Email inválido' }}
          InputProps={{ 
            endAdornment: <InputAdornment position="end"><Email color="action" /></InputAdornment>
          }}
        />

        {/* INPUT PASSWORD */}
        <TextFieldFormsy
          required 
          key={showPassword ? 'text' : 'password'}
          type={showPassword ? 'text' : 'password'}
          name="password"
          label="Senha"
          autoComplete="current-password"
          value={pwd}
          onChange={e => setPwd(e)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ gap: 0.5 }}>
                <Tooltip title={showPassword ? 'Ocultar senha' : 'Mostrar senha'} >
                  <IconButton
                    edge="end"
                    size="small"
                    onClick={() => setShowPassword(prev => !prev)}
                    onMouseDown={e => e.preventDefault()}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </Tooltip>
                <VpnKey color="action" fontSize="small" sx={{ mr: 0.5 }} />
              </InputAdornment>
            ),
          }}
        />

        <D h="1rem" />
        <D className="row w aC">
          <Button type="submit" variant="contained" color="primary" value="legacy">Entrar</Button>
        </D>
      </Formsy>
      <D h="1rem" />
      <D className="row w aC">
        <Link to="/forgot-password">
          <Typography variant="caption">Esqueceu a senha ?</Typography>
        </Link>
      </D>
    </Screen>
  )
}

// ==========================================
// RESET PASSWORD COMPONENT
// ==========================================
export function ResetPassword() {
  const { hash: urlHash, email: urlEmail } = useParams()
  const navigate = useNavigate()

  const [snackbar, setSnackbar] = useState(false)
  const [snackbarMsg, setSnackbarMsg] = useState('')
  const [email, setEmail] = useState(urlEmail || window.location.pathname.split('/')[3] || '')
  
  // <-- AJUSTE 2: Removido o 'setHash', mantendo apenas a leitura do 'hash'
  const [hash] = useState(urlHash || window.location.pathname.split('/')[2] || '')
  
  const [pwd, setPwd] = useState('')
  const [pwdConfirm, setPwdConfirm] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [showPasswordC, setShowPasswordC] = useState(false)

  const alertMessage = (m) => {
    setSnackbarMsg(m)
    setSnackbar(true)
  }

  const changePwd = () => {
    if (pwd === pwdConfirm) {
      axios.put(C.baseURL + 'updatePassword/' + hash + '/' + email, {
        password: pwd
      }, { timeout: 2000 }).then(() => {
        alertMessage('Senha alterada com sucesso.')
        setTimeout(() => navigate('/'), 1500)
      }).catch(() => {
        alertMessage('Não foi possível alterar a senha, link inválido !')
      })
    } else {
      alertMessage('A senha e a confirmação precisam ser iguais !')
    }
  }

  return (
    <Screen>
      <Typography variant="h6" className="row w aC">Troca de senha</Typography>
      <D h="1rem" />
      <Formsy onValidSubmit={changePwd} onInvalidSubmit={() => alertMessage('Preencha corretamente todos os campos !')}>

        <TextFieldFormsy type="text" name="email" autoComplete="email" defaultValue={email} value={email} label="Email" onChange={v => setEmail(v)}
          validations="isEmail" validationErrors={{ isEmail: 'Email inválido !' }}
          InputProps={{ endAdornment: <InputAdornment position="end"><Email /></InputAdornment> }} variant="outlined" required />

        <TextFieldFormsy
          key={'pwd-' + (showPassword ? 'text' : 'password')}
          type={showPassword ? 'text' : 'password'}
          name="password"
          autoComplete="new-password"
          label="Nova Senha"
          value={pwd}
          onChange={e => setPwd(e)}
          required
          validations={{ minLength: 4 }}
          validationErrors={{ minLength: 'Senha muito curta!' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ gap: 0.5 }}>
                <Tooltip title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}>
                  <IconButton
                    edge="end"
                    size="small"
                    onClick={() => setShowPassword(prev => !prev)}
                    onMouseDown={e => e.preventDefault()}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </Tooltip>
                <VpnKey color="action" fontSize="small" sx={{ mr: 0.5 }} />
              </InputAdornment>
            ),
          }}
        />

        <TextFieldFormsy
          key={'pwdC-' + (showPasswordC ? 'text' : 'password')}
          type={showPasswordC ? 'text' : 'password'}
          name="passwordConfirm"
          autoComplete="new-password"
          label="Confirmar Senha"
          value={pwdConfirm}
          onChange={e => setPwdConfirm(e)}
          required
          validations={{ minLength: 4 }}
          validationErrors={{ minLength: 'Senha muito curta!' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ gap: 0.5 }}>
                <Tooltip title={showPasswordC ? 'Ocultar senha' : 'Mostrar senha'}>
                  <IconButton
                    edge="end"
                    size="small"
                    onClick={() => setShowPasswordC(prev => !prev)}
                    onMouseDown={e => e.preventDefault()}
                  >
                    {showPasswordC ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </Tooltip>
                <VpnKey color="action" fontSize="small" sx={{ mr: 0.5 }} />
              </InputAdornment>
            ),
          }}
        />

        <D className="row w aC">
          <Button type="submit" variant="contained" color="primary">Trocar senha</Button>
        </D>
      </Formsy>
      <D h="1rem" />
      <D className="row w aC">
        <Link to="/login" id="backToLoginFromChangePwd">
          <Typography variant="caption">Voltar para login</Typography>
        </Link>
      </D>
      <Snackbar open={snackbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={6000}
        action={<Close onClick={() => { setSnackbar(false); setSnackbarMsg(''); }} />}
        message={snackbarMsg} onClose={() => { setSnackbar(false); setSnackbarMsg(''); }} />
    </Screen>
  )
}

// ==========================================
// FORGOT PASSWORD COMPONENT
// ==========================================
export function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [snackbar, setSnackbar] = useState(false)
  const [snackbarMsg, setSnackbarMsg] = useState('')

  const alertMessage = m => {
    setSnackbarMsg(m)
    setSnackbar(true)
  }

  const changePwdRequest = () => {
    axios.post(C.baseURL + 'forgotPassword', obj2form({ email })).then(r => {
      if (r.data.email === email) {
        alertMessage('Enviamos um email com as orientações para a troca de senha.')
      } else {
        const message = r.data.message || 'Não encontramos um usuário com este email !'
        alertMessage(message)
      }
    }).catch(() => alertMessage('Ocorreu um erro !'))
  }

  return (
    <Screen>
      <Typography variant="h6" className="row w aC">Recuperar minha senha</Typography>
      <D h="1rem" />
      <Formsy onValidSubmit={changePwdRequest}>
        <TextFieldFormsy type="text" name="email" autoComplete="email" value={email} label="Email" validations="isEmail" onChange={v => setEmail(v)}
          validationErrors={{ isEmail: 'Email inválido' }} InputProps={{ endAdornment: <InputAdornment position="end"><Email /></InputAdornment> }} variant="outlined" required />
        <D h="1rem" />
        <D className="row w aC">
          <Button variant="contained" type="submit">Enviar</Button>
        </D>
      </Formsy>
      <D h="1rem" />
      <D className="row w aC">
        <Link to="/login">
          <Typography variant="caption">Voltar para login</Typography>
        </Link>
      </D>
      <Snackbar open={snackbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={6000}
        action={<Close onClick={() => { setSnackbar(false); setSnackbarMsg(''); }} />}
        message={snackbarMsg} onClose={() => { setSnackbar(false); setSnackbarMsg(''); }} />
    </Screen>
  )
}

// ==========================================
// AUTH (MAIN CONTROLLER) COMPONENT
// ==========================================
export function Auth({ logout: shouldLogout }) {
  const navigate = useNavigate()

  // Estados Estruturais
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [email, setEmail] = useState('')
  const [token, setToken] = useState(() => (!!sessionStorage && sessionStorage.getItem('jwt_access_token')) || '')

  // Estados de UI Modais/Popups
  const [snackbar, setSnackbar] = useState(false)
  const [snackbarMsg, setSnackbarMsg] = useState('')
  const [dialogOpen, setDialogOpen] = useState(false)
  const [dialogChildren, setDialogChildren] = useState([])

  // Instância única do Axios persistida entre re-renderizações
  // const api = useRef(axios.create({ baseURL: C.baseURL }))
  const [api] = useState(() => axios.create({ baseURL: C.baseURL }))

  const alertMessage = m => {
    setSnackbarMsg(m)
    setSnackbar(true)
  }

  const dialog = m => {
    setDialogOpen(true)
    setDialogChildren(m)
  }

  const dialogClose = () => {
    setDialogOpen(false)
    setDialogChildren([])
  }

  const handleSetToken = (t) => {
    if (t) {
      if (sessionStorage) sessionStorage.setItem('jwt_access_token', t)
      // api.defaults.headers.common['Authorization'] = 'Bearer ' + t
      setToken(t)
    } else {
      if (sessionStorage) sessionStorage.removeItem('jwt_access_token')
      // delete api.defaults.headers.common['Authorization']
      setToken('')
    }
  }

  const logout = () => {
    try {
      sessionStorage.removeItem('username')
      sessionStorage.removeItem('session_active')
      if (email) {
        api.post('/logout', { username: email })
      }
    } catch (error) {
      console.error('Erro ao registrar logout:', error)
    }

    handleSetToken('')
    setUser(null)
    setLoading(false)

    if (shouldLogout) {
      navigate('/', { replace: true })
    }
  }

  const updateAppData = (callback) => {
    api.post('/auth/access-token', { access_token: token })
      .then(r => {
        if (r.user) {
          handleSetToken(r.access_token)
          setUser(r.user)
          if (typeof callback === 'function') callback()
        } else {
          logout()
        }
      })
      .catch(() => logout())
      .finally(() => setLoading(false))
  }

  const login = (emailInput, passwordInput) => {
    if (emailInput && passwordInput) {
      api.post('/sessions', { email: emailInput, password: passwordInput })
        .then(r => {
          if (typeof r === 'string') return alertMessage(r)

          if (!r.error && r.user.email === emailInput) {
            handleSetToken(r.access_token)
            sessionStorage.setItem('username', emailInput)
            sessionStorage.setItem('session_active', 'true')
            setEmail(emailInput)
            setUser(r.user)
            alertMessage('Sessão iniciada com sucesso.')
          } else {
            alertMessage('Usuário ou senha incorretos !')
          }
        })
        .catch(() => logout())
    }
  }

  // Inicialização única dos interceptores do Axios
  useEffect(() => {
    // Interceptor de Requisição: Injeta o token automaticamente
    const requestInterceptor = api.interceptors.request.use(config => {
      const currentToken = sessionStorage.getItem('jwt_access_token')
      if (currentToken) {
        config.headers['Authorization'] = 'Bearer ' + currentToken
      }
      return config
    })

    // Interceptor de Resposta: Trata os erros
    const responseInterceptor = api.interceptors.response.use(
      res => {
        if (res.data.status === 'NoApiAccess') {
          alertMessage('Você não tem acesso a esta funcionalidade.')
          return {}
        }
        return res.data
      }, 
      err => {
        if (!!err.response && err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
          alertMessage('Sessão expirada, entre com seus dados de acesso.')
        } else {
          alertMessage('Erro ao conectar com servidor !')
        }
        return {}
      }
    )

    return () => {
      api.interceptors.request.eject(requestInterceptor)
      api.interceptors.response.eject(responseInterceptor)
    }
  }, [api])


  useEffect(() => {
    if (shouldLogout) {
      setTimeout(() => {
        logout()
      }, 0)
      return
    }

    const sessionActive = sessionStorage.getItem('session_active')
    if (sessionActive && token) {
      updateAppData(() => alertMessage('Sessão restaurada com sucesso.'))
    } else {
      // Resolve o "Calling setState synchronously within an effect"
      setTimeout(() => {
        setLoading(false)
      }, 0)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldLogout])

  return (
    <D className="row e aF scD">
      {loading ? (
        <Loading style={{ backgroundColor: '#424242' }} />
      ) : !user ? (
        <Login doLogin={login} />
      ) : (
        <MainPage
          api={api}
          user={user}
          logout={logout}
          alert={alertMessage}
          dialog={dialog}
          dialogClose={dialogClose}
          updateAppData={updateAppData} 
        />
      )}

      <Dialog open={dialogOpen} onClose={dialogClose}>{dialogChildren}</Dialog>
      
      <Snackbar
        open={snackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        autoHideDuration={7000}
        action={<Close onClick={() => { setSnackbar(false); setSnackbarMsg(''); }} />}
        message={<Typography style={{ whiteSpace: 'pre-line' }}>{snackbarMsg}</Typography>}
        onClose={() => { setSnackbar(false); setSnackbarMsg(''); }}
      />
    </D>
  )
}